import DeviceAssignmentReasonsList from './DeviceAssignmentReasonsList';

export default DeviceAssignmentReasonsList;
